import { OnChanges, OnInit } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { FullMenuService } from './full-menu.service';
import { UtilService } from '@app/shared/utils';
var FullMenuComponent = /** @class */ (function () {
    function FullMenuComponent(activeRoute, fullMenuService, util) {
        this.activeRoute = activeRoute;
        this.fullMenuService = fullMenuService;
        this.util = util;
    }
    FullMenuComponent.prototype.ngOnInit = function () {
        var _this = this;
        this.menu$ = this.fullMenuService.filterMenuThroughURLParameters(this.activeRoute);
        this.menu$.subscribe(function (menuParameters) {
            _this.assignMenuProperties(menuParameters);
        });
        this.fullMenuService.getMenuTabindex().subscribe(function (menuTabIndex) {
            _this.menuTabIndex = menuTabIndex;
            setTimeout(function () {
                _this.util.requestFocusOnFirstOcurrence('menu-suboption-card');
            }, 100);
        });
        this.fullMenuService.getSelectedTranslationKeyCategory().subscribe(function (selectedTranslationKeyCategory) {
            var classToFind = 'menu-suboption-card';
            if (selectedTranslationKeyCategory.length > 0 != undefined && selectedTranslationKeyCategory.length > 0) {
                classToFind += " link_" + selectedTranslationKeyCategory;
            }
            setTimeout(function () {
                _this.util.requestFocusOnFirstOcurrence(classToFind);
            }, 100);
        });
    };
    FullMenuComponent.prototype.ngOnChanges = function () {
        var _this = this;
        this.menu$.subscribe(function (menuParameters) {
            _this.assignMenuProperties(menuParameters);
        });
    };
    FullMenuComponent.prototype.assignMenuProperties = function (menuParameters) {
        this.menuCategoryName = menuParameters.category;
        this.menuName = menuParameters.name;
        this.menu = menuParameters.menu;
        if (this.menu)
            this.menuDescription = menuParameters.menu.description;
        if (this.menu)
            this.translationKey = menuParameters.menu.translationKey;
    };
    return FullMenuComponent;
}());
export { FullMenuComponent };
